import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { Card } from 'components/ui';

import { PublicRoute } from './components/PublicRoute';
import { ProtectedRoute } from './components/ProtectedRoute';
import Form from './components/OnboardingForm/Form';
import { FORM_ROUTES } from './components/OnboardingForm/constants';
import ThankYou from './components/ThankYouView/ThankYou';
import { PlansPage } from './components/PlansView/PlansPage';
import Eligibility from './components/EligibilityView/Eligibility';
import { useAuth } from './hooks';
import { useModal } from './hooks/useModal';
import UnsubscribedLanding from './components/UnsubscribedLanding/UnsubscribedLanding';
import PhoneNumber from './components/PhoneNumberView/PhoneNumber';
import Ineligible from './components/IneligibleView/Ineligible';
import { LoginPage } from './components/LoginView/LoginPage';
import { ScheduleAppointment } from './components/ScheduleAppointmentView/ScheduleAppointment';
import { FeedbackPage } from './components/FeedbackView/FeedbackPage';
import { UrlNormalizer } from './utils/UrlNormalizer';
import { CatchAllRoute } from './utils/CatchAllRoute';
import { Location } from './components/LocationView/Location';
import { UTMManager } from './utils/UtmManager';
import { HealthPlan } from './components/HealthPlanView/HealthPlan';
import { AccountHome } from './components/AccountView/AccountHome';
import { AccountHealthPlan } from './components/AccountView/AccountHealthPlan';
import { AccountProfile } from './components/AccountView/AccountProfile';
import CustomAccount from './components/CustomAccount';
import { AMAZON_HBC_SOURCE } from './constants/utms';

const Main = () => {
  const { user, userData } = useAuth();

  return (
    <>
      <div
        className="background-container"
        style={{ overflowX: 'hidden' }}
      ></div>

      <Form />

      {user && (
        <Card>
          <pre>{JSON.stringify(user, null, 2)}</pre>
        </Card>
      )}

      {userData && (
        <Card>
          <pre>{JSON.stringify(userData, null, 2)}</pre>
        </Card>
      )}
    </>
  );
};

export const Root = () => {
  const modalToRender = useModal();

  return (
    <>
      {modalToRender}

      <Router>
        <UrlNormalizer />

        <UTMManager />

        <Routes>
          <Route
            path="/"
            element={
              <PublicRoute>
                <Main />
              </PublicRoute>
            }
          />

          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />

          <Route path="/eligibility" element={<Eligibility />} />

          <Route path="/feedback" element={<FeedbackPage />} />

          <Route path="/health-plan" element={<HealthPlan />} />

          <Route path="/ineligible" element={<Ineligible />} />

          <Route path="/location" element={<Location />} />

          {FORM_ROUTES.map((path) => (
            <Route key={path} path={path} element={<Form />} />
          ))}

          <Route path="/phone" element={<PhoneNumber />} />

          <Route path="/plans" element={<PlansPage />} />

          <Route
            path="/schedule-appointment"
            element={<ScheduleAppointment />}
          />

          <Route
            path="/account"
            element={
              <ProtectedRoute>
                <AccountHome />
              </ProtectedRoute>
            }
          />

          <Route
            path="/account/profile"
            element={
              <ProtectedRoute>
                <AccountProfile />
              </ProtectedRoute>
            }
          />

          <Route
            path="/account/health-plan"
            element={
              <ProtectedRoute>
                <AccountHealthPlan />
              </ProtectedRoute>
            }
          />

          <Route path="/thank-you" element={<ThankYou />} />

          <Route
            path="/unsubscribed-landing"
            element={
              <ProtectedRoute>
                <UnsubscribedLanding />
              </ProtectedRoute>
            }
          />

          <Route
            path={`/${AMAZON_HBC_SOURCE}/:applicationId`}
            element={<CustomAccount />}
          />

          <Route path="*" element={<CatchAllRoute />} />
        </Routes>
      </Router>
    </>
  );
};
